import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { SiteState } from '@stores/site';
import { map } from 'rxjs';
import Parse from 'parse';

export const siteGuard: CanActivateFn = async (route, state) => {
  const store = inject(Store);
  const router = inject(Router);

  const inviteCode = route.paramMap.get('code');
  if (inviteCode) {
    sessionStorage.setItem('inviteCode', inviteCode);
  }

  const currentUser = await Parse.User.currentAsync();
  const isAuthenticated = currentUser && currentUser.authenticated();
  if (!isAuthenticated) {
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url },
    });
  }

  const isInitialized = store.selectSnapshot(SiteState.isInitalized);
  if (!isInitialized) {
    return router.createUrlTree(['/loading'], {
      queryParams: { returnUrl: state.url },
    });
  }

  return true;
};
